import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  filtersPaperChildContainer: {
    padding: theme.spacing(2),
  },
  filtersTitle: {
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: theme.typography.fontWeightBold as number,
    fontFamily: theme.typography.body1.fontFamily,
    marginBottom: theme.spacing(1),
  },
}));
